export default __webpack_public_path__ + "static/media/unique.8b24d95f.jpg";